import { EventCategoryEnum } from "@/v2/enum/events";
import {
  analyticsEventCommonData,
  ITrackEvent,
  trackEvent,
} from "@/v2/util/analytics/trackEvent";

interface IReviewsTrack {
  businessId: string;
}

export function reviewsTrack({
  analytics,
  eventName,
  businessId,
  additionalData = {},
}: ITrackEvent & IReviewsTrack): void {
  trackEvent({
    eventCategory: EventCategoryEnum.REVIEWS,
    analytics,
    eventName,
    additionalData: {
      ...analyticsEventCommonData([["business", businessId]]),
      ...additionalData,
    },
  });
}
